<!-- Initial State: Yes / No / Skip -->
<div *ngIf="currentState === 'initial'">
  <h2 mat-dialog-title>Hospital Group Email</h2>
  <mat-dialog-content>
    <p>
      Great news! In addition to adding your hospital's email address to receive notifications, you may now
      customize which notifications are cc'd to this address. You can also add your hospital's phone number to
      assist in record retrieval or case follow up. Would you like to update your hospital's contact preferences now?
    </p>
    <p *ngIf="data?.practiceName || data?.hospitalCode" class="clinic-name">
      Clinic name: <strong>{{ data.practiceName }}</strong><span *ngIf="data?.hospitalCode">, ({{ data.hospitalCode }})</span>
    </p>
    <p class="dialog-note">
      You can edit, add, or remove either contact later by visiting your profile.
    </p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button color="primary" (click)="onSkip()">Skip For Now</button>
    <button mat-button color="warn" (click)="onNo()">No, Thank You</button>
    <button mat-raised-button color="primary" (click)="onYes()">Yes</button>
  </mat-dialog-actions>
</div>

<!-- Contact Input State -->
<div *ngIf="currentState === 'contactInput'">
  <h2 mat-dialog-title>Enter Hospital Contact Details</h2>
  <mat-dialog-content>
    <p>Enter your hospital’s email address, phone number, or both. Please note, no notifications will be sent to the hospital phone number.</p>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Hospital Email</mat-label>
      <input matInput type="email" [formControl]="emailControl" placeholder="email@yourcompany.com">
      <mat-error *ngIf="emailControl.hasError('email')">
        Please input a valid email address
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Hospital Phone</mat-label>
      <input matInput type="tel" [formControl]="phoneControl" mask="(000) 000-0000"
        [dropSpecialCharacters]="false" placeholder="(___) ___-____">
      <mat-error *ngIf="phoneControl.hasError('pattern')">Please input a valid phone number</mat-error>
    </mat-form-field>
    <div *ngIf="domainError" class="domain-error">
      {{ domainError }}
    </div>
    <div *ngIf="contactError" class="domain-error">{{ contactError }}</div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="onBackToInitial()">Back</button>
    <button mat-raised-button color="primary" (click)="onSubmitContacts()">Submit</button>
  </mat-dialog-actions>
</div>

<!-- Confirmation State -->
<div *ngIf="currentState === 'confirm'">
  <h2 mat-dialog-title>Confirm Hospital Contact Details</h2>
  <mat-dialog-content>
    <p *ngIf="data?.practiceName || data?.hospitalCode" class="clinic-name">
      Clinic name: <strong>{{ data.practiceName }}</strong><span *ngIf="data?.hospitalCode">, ({{ data.hospitalCode }})</span>
    </p>
    <p>You entered the following contact details:</p>
    <p class="confirm-email" *ngIf="enteredEmail"><strong>{{ enteredEmail }}</strong></p>
    <p class="confirm-email" *ngIf="enteredPhone"><strong>{{ enteredPhone }}</strong></p>
    <p class="confirm-email" *ngIf="!enteredEmail && !enteredPhone"><strong>No hospital contact details</strong></p>
    <p>Is this correct?</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="onConfirmEdit()">No, Edit Contact Details</button>
    <button mat-raised-button color="primary" (click)="onConfirmYes()">Yes, This Is Correct</button>
  </mat-dialog-actions>
</div>
